module.exports = __webpack_public_path__ + "fonts/CCBackBeatLight.cfbab2e.woff";